import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components/macro';

const StyledSkipLink = styled.a`
  position: absolute;
  top: -100px;
  left: 0;
  background: #F6FAFF; /* 請根據專案色調調整 */
  color: #000000;
  padding: 10px 20px;
  z-index: 10000;
  text-decoration: none;
  font-weight: bold;

  &:focus {
    top: 0;
    outline: 3px solid #ffcc00;
  }
`;

const SkipLink = () => {
	const { pathname } = useLocation();
	  const isFirstRender = useRef(true); // 使用 Ref 記錄是否為第一次渲染

	  useEffect(() => {
	    // 無論是否為第一次，換頁都要捲動到頂部
	    window.scrollTo(0, 0);

	    // 關鍵：如果是第一次載入（重新整理），不執行 focus()
	    if (isFirstRender.current) {
	      isFirstRender.current = false;
	      return;
	    }

	    // 只有在之後的「路由切換」才自動聚焦到主內容
	    const mainContent = document.getElementById('main-content');
	    if (mainContent) {
	      mainContent.focus();
	    }
	  }, [pathname]);
	
	
  // 若此專案尚未整合 i18next，可先使用中文，或視需求加入翻譯邏輯
  return (
    <StyledSkipLink href="#main-content">
      跳到主要內容
    </StyledSkipLink>
  );
};

export default SkipLink;